<style>
    body {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        margin: 20px;
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: bold;
        margin-top: 20px;
    }

    p {
        margin: 10px 0;
    }

    ul {
        margin: 10px 0 10px 20px;
    }

    a {
        color: blue;
        text-decoration: none;
    }
</style>
<div class="head" style="display: flex; align-items: center;">
    <img src="assets/images/mobilize-logo-small.png" alt="logo" width="150px">
    <a href="javascript: window.close()" class="mobilize-btn btn-orange">inchide</a>
</div>
<div class="static-page-wrapper">
    <img src="assets/images/logo.png">
    <div class="static-page-title">Termeni și condiții</div>

    <div class="static-page-content">
        <p>
            Website-ul <a href="http://my.mobilize-fs.ro" target="_blank">my.mobilize-fs.ro</a> este un spațiu online
            dedicat clienților Mobilize Financial Services, denumire comercială sub care operează societățile RCI
            Romania, cu acces securizat și personalizat la informații utile din contractul individual de finanțare
            încheiat cu RCI Leasing Romania IFN S.A și/sau RCI Romania Finantare SRL și/sau RCI Broker de Asigurare SRL.
            Proprietarii site-ului <a href="http://my.mobilize-fs.ro" target="_blank">my.mobilize-fs.ro</a> sunt
            societățile RCI Leasing România IFN S.A., RCI Finantare Romania SRL și RCI Broker de Asigurare SRL, având
            datele de identificare menționate în secțiunea <strong>DATE DE CONTACT</strong>.
        </p>

        <h2>Definiții</h2>
        <p>
            <strong>Termenii “site”, “acest site” și “site-ul”</strong> folosiți în acest document se referă la site-ul
            <strong>my.mobilize-fs.ro</strong> și subdomeniile lui.
        </p>
        <p>
            <strong>RCI Romania</strong> – orice referire la una dintre companiile din grupul RCI: RCI Leasing România
            IFN S.A., RCI Finantare Romania SRL sau RCI Broker de Asigurare SRL.
        </p>
        <p>
            <strong>Vizitator</strong> – orice persoană care accesează site-ul <strong>my.mobilize-fs.ro</strong>,
            indiferent de motiv.
        </p>
        <p>
            <strong>Utilizator</strong> – persoană fizică care are sau obține acces la conținut, prin mijloacele de
            comunicare puse la dispoziție de RCI Romania sau în baza unui acord de utilizare existent între RCI Romania
            și acesta, și care și-a dat acordul în mod implicit cu termenii și condițiile de utilizare a site-ului.
        </p>

        <p><strong>Prin „conținut” înțelegem:</strong></p>
        <ul>
            <li>toate informațiile de pe site care pot fi vizitate, vizualizate sau altfel accesate prin utilizarea unui
                echipament numeric;
            </li>
            <li>conținutul oricărui e-mail trimis utilizatorilor sau clienților săi de către RCI, prin mijloace
                electronice și/sau orice alt mijloc de comunicare disponibil;
            </li>
            <li>informații legate de produsele, serviciile și/sau tarifele practicate de RCI.</li>
        </ul>

        <p>
            <strong>Client</strong> – poate fi orice persoană fizică care are vârsta peste 18 ani sau persoană juridică
            care are sau obține acces la <strong>CONTINUT</strong>, prin orice mijloc de comunicare pus la dispoziție de
            către RCI Româna (electronic, telefonic etc.) sau în baza unui acord de utilizare existent între RCI Romania
            și acesta și care necesită crearea și utilizarea unui Cont.
        </p>

        <p>
            <strong>Date cu caracter personal</strong> – informațiile pe care le colectăm de la dumneavoastră, pe baza
            cărora puteți fi identificat și care vă sunt asociate. Pentru o prezentare a modului în care gestionăm
            datele dumneavoastră personale vă rugăm să consultați din meniul site-ului documentul <strong>Politica de
            Confidentialitate</strong>.
        </p>

        <p>
            <strong>Nickname</strong> – pseudonim prin care un anumit Utilizator/Client poate adăuga Conținut pe Site.
            Nickname-ul este asociat informațiilor din Site ale Utilizatorului/Clientului sub denumirea de “Nume
            Utilizator”.
        </p>

        <p>
            <strong>Cont</strong> – secțiunea din Site formată dintr-o adresă de e-mail și o parolă care permite
            Clientului transmiterea Comenzii și care conține informații despre Client/Client și istoricul Clientului în
            Site (Comenzi, facturi fiscale, garanții Bunuri, contracte de asigurare etc.). Utilizatorul este responsabil
            și se va asigura că toate informațiile introduse la crearea Contului sunt corecte, complete și actualizate.
        </p>

        <p>
            <strong>Lista</strong> – secțiunea din Favorite în care Clientul/Utilizatorul poate adăuga Servicii pe care
            dorește să le urmărească în vederea unei eventuale achiziții și pe care, ulterior, le poate șterge sau le
            poate adăuga în coșul de cumpărături („Cosul meu”).
        </p>

        <p>
            <strong>Site</strong> – spațiul personal online găzduit la adresa web <a href="http://my.mobilize-fs.ro"
                                                                                     target="_blank">my.mobilize-fs.ro</a>
            și subdomeniile acestuia.
        </p>

        <p>
            <strong>Campanie</strong> – acțiunea de a expune în scop comercial, un număr finit de Servicii având un stoc
            limitat și predefinit, pentru o perioadă limitată de timp stabilită de către RCI Romania.
        </p>

        <p>
            <strong>Conținut</strong> – reprezintă:
        </p>
        <ul>
            <li>toate informațiile de pe Site care pot fi vizitate, vizualizate sau altfel accesate prin utilizarea unui
                echipament electronic;
            </li>
            <li>conținutul oricărui e-mail trimis Clienților de către RCI Romania prin mijloace electronice și/sau orice
                alt mijloc de comunicare disponibil;
            </li>
            <li>orice informație comunicată prin orice mijloc de către un angajat/colaborator al RCI Romania,
                Clientului, conform informațiilor de contactare, specificate sau nu de către acesta;
            </li>
            <li>informații legate de Bunurile și/sau Serviciile și/sau tarifele practicate de RCI Romania într-o anumită
                perioadă;
            </li>
            <li>informații legate de Bunurile și/sau Serviciile și/sau tarifele practicate de către un tert cu care RCI
                Romania are încheiate contracte de parteneriat, într-o anumită perioadă;
            </li>
            <li>date referitoare la RCI Romania sau alte date privilegiate ale acestuia.</li>
        </ul>

        <p>
            <strong>Document</strong> – prezentele Termene și Condiții.
        </p>

        <p>
            <strong>Comunicări Comerciale</strong> – orice tip de mesaj trimis (cum ar fi: e-mail/SMS/telefonic/mobile
            push/webpush etc.) conținând informații generale și tematice, informații cu privire la produse similare sau
            complementare cu cele pe care le-ați achiziționat, informații cu privire la oferte sau promoții, informații
            referitoare la Bunuri și Servicii adăugate în secțiunea “Cont/Cosul meu” sau secțiunea “Cont/Favorite”
            precum și alte comunicări comerciale, cum ar fi cercetări de piață și sondaje de opinie.
        </p>

        <p>
            <strong>Tranzacție</strong> – încasarea sau rambursarea unei sume rezultate din vânzarea unui Serviciu de
            către RCI Romania prin plata online cu cardul bancar, Clientului, prin utilizarea serviciilor procesatorului
            de carduri agreat de către RCI Romania, indiferent de modalitatea de livrare. Serviciile care pot fi
            achitate prin plata online cu cardul sunt cele de mai jos, fără a se limita la acestea:
        </p>
        <ul>
            <li>Plata ratelor lunare</li>
            <li>Plata facturilor lunare</li>
            <li>Plata sold total restant</li>
            <li>Plata sold total</li>
            <li>Plata primelor de asigurare de tip RCA, CASCO, Trafic Accident.</li>
        </ul>
        <p>
            Procesatorul de plăți agreat de RCI Romania este <strong>BRD - GROUPE SOCIETE GENERALE SA</strong>. Plățile
            se vor efectua pe site exclusiv în moneda <strong>RON</strong>.
        </p>

        <h2>ACCEPTAREA “TERMENILOR SI CONDITIILOR”</h2>
        <p>
            Înainte de a viziona acest site, vă rugăm să citiți cu atenție precizările următoare. Ele stabilesc termenii
            și condițiile utilizării de către dumneavoastră a tuturor materialelor care alcătuiesc prezentul site.
            Accesarea site-ului și folosirea aplicațiilor sale presupun acceptarea explicită sau implicită a tuturor
            Termenilor și Condițiilor publicate, acestea având valoare contractuală deplină.
        </p>
        <p>
            RCI Romania își rezervă dreptul de a modifica în orice moment conținutul prezentului site. Folosirea în
            continuare a site-ului de către utilizator constituie un răspuns afirmativ de acceptare a modificărilor
            aduse prezentului contract.
        </p>

        <h2>CONTINUTUL SITE-ULUI</h2>
        <p>
            Conținutul, astfel cum este definit, incluzând, dar nelimitându-se la logo-uri, reprezentări stilizate,
            simboluri comerciale, imagini statice, imagini dinamice, text și/sau conținut multimedia prezentate pe site,
            sunt proprietatea exclusivă a RCI Romania, acesteia fiind rezervate toate drepturile obținute în acest sens,
            în mod direct sau indirect (prin licențe de utilizare și/sau publicare). Utilizatorilor nu le este permisă
            copierea, distribuirea, publicarea, transferul către terți, modificarea și/sau alterarea în orice alt mod,
            utilizarea, expunerea sau includerea oricărui conținut în orice alt context decât cel original.
        </p>
        <p>
            De asemenea, utilizatorilor nu le este permis să copieze sau să modifice codul sursă al aplicațiilor ce
            susțin webserver-ul și pagina web, să efectueze teste de penetrare și să falsifice în orice mod originea
            website-ului. Informațiile publicate pe site sunt informații de interes general despre <a
            href="http://my.mobilize-fs.ro" target="_blank">my.mobilize-fs.ro</a>, produsele prezentate, opiniile
            utilizatorilor despre produse, precum și alte informații considerate ca fiind de interes pentru utilizatori.
        </p>
        <p>
            Proprietarul site-ului își rezervă dreptul să completeze și să modifice orice informație de pe acest site.
            RCI Romania își rezervă dreptul de a corecta eventualele omisiuni sau erori de afișare care pot surveni în
            urma unor greșeli de dactilografiere, lipsa de acuratețe sau erori ale produselor software, fără a anunța în
            prealabil. Implicit, RCI Romania nu își asumă răspunderea pentru eventualele erori de preț sau stoc. Aceste
            erori nu obligă RCI Romania la nicio acțiune.
        </p>
        <p>
            Prețurile și disponibilitatea serviciilor comercializate pot suferi modificări ulterioare, acest lucru fiind
            influențat de factori externi, precum politica de prețuri a distribuitorilor sau disponibilitatea produselor
            pe stocul acestora. De obicei, informațiile sunt puse gratuit la dispoziția utilizatorilor.
        </p>

        <h2>COMUNICARI COMERCIALE</h2>
        <p>
            Clientul/Utilizatorul își poate modifica în orice moment opțiunea cu privire la acordul dat RCI Romania
            pentru Comunicarile Comerciale, conținând informații generale și tematice inclusiv informații cu privire la
            oferte sau promoții, după cum urmează:
        </p>
        <ul>
            <li>prin modificarea setărilor din Contul Meu;</li>
            <li>prin accesarea link-ului de dezabonare afișat în Comunicarile Comerciale primite de la RCI Romania;</li>
            <li>sau prin contactarea RCI Romania.</li>
        </ul>

        <h2>RASPUNDERE</h2>
        <p>
            RCI Romania nu poate fi responsabil pentru daune de orice fel pe care Clientul sau orice terță parte o poate
            suferi ca rezultat al îndeplinirii de către RCI Romania a oricăreia din obligațiile sale conform Comenzii și
            pentru daune care rezultă din utilizarea Bunurilor și Serviciilor după livrare, în special pentru pierderea
            acestora.
        </p>
        <p>
            Prin crearea și utilizarea Contului, Utilizatorul/Clientul își asumă răspunderea pentru menținerea
            confidențialității datelor de Cont (user și parolă) și pentru gestionarea accesării Contului și, în măsura
            permisă de legislația în vigoare, este responsabil de activitatea derulată prin intermediul Contului său.
        </p>
        <p>
            Prin crearea Contului și/sau utilizarea Conținutului, Clientul/Utilizatorul/Clientul acceptă în mod expres
            și fără echivoc Termenele și Condițiile Site-ului în ultima versiune actualizată, comunicată în cadrul
            Site-ului, existentă la data creării Contului și/sau utilizării conținutului. RCI Romania își rezervă
            dreptul de a actualiza și modifica periodic Termenele și Condițiile Site-ului pentru a reflecta orice
            modificări ale modului și condițiilor de funcționare a Site-ului sau orice modificări ale cerințelor legale.
            Documentul este opozabil Clienților/Utilizatorilor de la momentul afișării în Site. În cazul oricărei
            modificări, vom afișa pe Site versiunea modificată a documentului.
        </p>

        <h2>COPYRIGHT</h2>
        <p>
            Conținutul site-ului <a href="http://my.mobilize-fs.ro" target="_blank">my.mobilize-fs.ro</a> – imagini,
            texte, grafice, simboluri, elemente de grafică WEB, scripturi, programe și alte date – este proprietatea RCI
            Romania și a furnizorilor săi și este aparat de legea pentru protecția drepturilor de autor. Astfel,
            folosirea în scopuri comerciale, fără acordul RCI Romania, a oricăruia dintre elementele enumerate mai sus
            se pedepsește conform legilor în vigoare.
        </p>

        <h2>LEGĂTURI</h2>
        <p>
            Site-ul RCI Romania poate găzdui legături (link-uri) către alte site-uri World Wide Web sau alte resurse.
            Răspunderea pentru aceste site-uri o poartă în întregime proprietarii acestora. RCI Romania nu își asumă
            responsabilitatea pentru nicio pagubă sau pierdere cauzată sau presupusă a fi cauzată de informațiile
            furnizate de site-urile sau resursele spre care trimit aceste link-uri.
        </p>

        <h2>PARTENERI</h2>
        <p>
            Despre calitatea produselor, despre autenticitatea mărcii și despre orice alte nelămuriri referitoare la o
            anumită marcă sau la un anumit serviciu, clientul se poate adresa reprezentantului mărcii respective sau
            furnizorului de serviciu.
        </p>

        <h2>DECLINAREA RESPONSABILITĂȚII</h2>
        <p>
            O parte din conținutul site-ului, respectiv textele, descrierile produselor, caracteristicile lor tehnice,
            imaginile și simbolurile lor, este pusă la dispoziția noastră de furnizorii parteneri. Din acest motiv, RCI
            Romania nu își asumă responsabilitatea pentru prejudiciile create de erorile, lipsa de acuratețe sau
            neactualizarea informațiilor publicate sau menținute pe site.
        </p>
        <p>
            RCI Romania nu-și asumă responsabilitatea cu privire la conținutul comentariilor postate de utilizatori
            referitor la serviciile comercializate; cu toate acestea, își rezervă dreptul de a șterge orice conținut
            care încalcă Termenii și Condițiile prezentului site sau care este incompatibil cu scopul site-ului.
        </p>
        <p>
            Totodată, RCI Romania nu își asumă responsabilitatea pentru monitorizarea permanentă a întregului conținut
            găzduit pe site și nu răspunde pentru pagubele, costurile, procesele, pretențiile sau cheltuielile apărute
            ca urmare a nerespectării de către utilizatori a “Termenilor și Condițiilor” sau a nefuncționării site-ului.
        </p>

        <h2>PROMOȚII ȘI CONCURSURI</h2>
        <p>
            Promoțiile și concursurile care se desfășoară pe site respectă regulamentele create de RCI Romania. Aceste
            regulamente sunt aduse la cunoștința utilizatorilor prin intermediul site-ului propriu, prin mesaje de poștă
            electronică sau în rețeaua sa de distribuție. RCI Romania își rezervă dreptul de a întrerupe sau de a anula
            o promoție în orice moment, fără nicio notificare prealabilă.
        </p>

        <h2>FRAUDA</h2>
        <p>
            Orice încercare de a accesa datele cu caracter personal ale altui utilizator, de a modifica conținutul
            site-ului <a href="http://my.mobilize-fs.ro" target="_blank">my.mobilize-fs.ro</a> sau de a afecta
            funcționarea serverului care găzduiește site-ul va fi considerată o tentativă de fraudare și va putea avea
            drept consecință angajarea răspunderii autorului sau autorilor acestor fapte.
        </p>

        <p>*versiune 15.04.2025</p>
    </div>
</div>
